// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import { sync } from 'vuex-router-sync'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './style/index.less'
 
import nomore from './components/nomore.vue'
Vue.component('nomore', nomore)

import topnav from './components/topnav.vue'
Vue.component('topnav', topnav)
import footer from './components/footer.vue'
import cookie from 'js-cookie'
Vue.prototype.$cookie = cookie;
Vue.component('sfooter', footer)

import broadcasting from './components/shock/broadcasting.vue'
Vue.component('broadcastingpage', broadcasting)

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

Vue.prototype.$echarts1 = function (el) {
  return echarts.init(el, null, { renderer: 'canvas' })
}


import Clipboard from 'v-clipboard'
Vue.use(Clipboard)

let timer, flag;
Vue.prototype.$throttle = function(func, wait = 200, immediate = true) {
	if (immediate) {
		if (!flag) {
			flag = true;
			// 如果是立即执行，则在wait毫秒内开始时执行
			typeof func === 'function' && func();
			timer = setTimeout(() => {
				flag = false;
			}, wait);
		}
	} else {
		if (!flag) {
			flag = true
			// 如果是非立即执行，则在wait毫秒内的结束处执行
			timer = setTimeout(() => {
				flag = false
				typeof func === 'function' && func();
			}, wait);
		}
		
	}
};

// import AMap from 'vue-amap';
// Vue.use(AMap);

// 引用axios
import api from './api/api.js'
Vue.prototype.$api = api
Vue.use(ElementUI)


 

sync(store, router)
var whiteList = [ '/newindex', '/login', '/dataview', '/page1', '/page2', '/page3', '/page4', '/matche', '/comdetail', '/companystack', '/newcheck', '/functions', '/bulletin', '/checkintest', '/teamdetail', '/test', '/testword', '/index', '/bindphone', '/', '/search', '/policylibrary', '/companylist', '/wisdom', '/policyweb', '/teamwork', '/aboutus', '/snotice', '/snoticedetail', '/scompany', '/scompanytwo', '/vector']
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('userid')
  // console.log(to.path)
  // console.log(whiteList)
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  if (whiteList.indexOf(to.path) != -1) {
    // console.log("白名单")
    next()
    return
  }


  // if(!token){
  //   // websocketRequest.closeWebSocket();
  //   next('/login');
  //   return
  // }
  //配置动态路由信息
  let newRouter = null;

  // if(store.getters.newRouter === newRouter)
  next()
  // else{
  //     router.addRoutes(newRouter) //添加动态路由
  //     store.dispatch('routerAction',newRouter).then(res => {
  //       next({ ...to })
  //     }).catch(() => {
  //     })
  // }
})
Vue.prototype.$yu = "http://fzjz.harborn.cn/FZJZ/";
Vue.filter('addurl', function (value) {
  let url = value;
  // http://gdtest.harborn.cn/GDDB/plugs/img/newImg/b041cb4ca8cc43cf9a0e998d8f1f9d44.png
  if (url) {
    if (value.indexOf("http") == -1) {
      url = 'http://fzjz.harborn.cn/FZJZ/plugs/' + value
    }
  }
  return url
})
Vue.config.productionTip = false
router.afterEach((to, from, next) => {
  if (to.matched.length == 0) {
    console.log(5555)
    router.push({
      path: "/"
    });
    return
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js